/**
* Waits until next repaint to execute a fn
* @param {Function} fn
*/
export default function defer(fn) {
  window.requestAnimationFrame(() => {
    setTimeout(fn, 0)
  })
}



// WEBPACK FOOTER //
// ./src/Tooltip/js/utils/defer.js


// WEBPACK FOOTER //
// webpack:///src/Tooltip/js/utils/defer.js